import { MapComment } from "@nova/protobuf"
import {
    latitudeValidators,
    longitudeValidators,
    UnionToTuple,
    entityValidator,
    idValidators,
    createdByValidators,
} from "../util"
import { dateAsNumber } from "../../util"

export const createCommentValidator = entityValidator(MapComment, {
    id: { validators: idValidators, nonNull: true },
    longitude: {
        validators: longitudeValidators,
        nonNull: true,
    },
    latitude: {
        validators: latitudeValidators,
        nonNull: true,
    },
    createdBy: {
        validators: createdByValidators,
        nonNull: true,
    },
})

export const updateCommentValidator = entityValidator(MapComment, {
    longitude: {
        validators: longitudeValidators,
        nonNull: true,
    },
    latitude: {
        validators: latitudeValidators,
        nonNull: true,
    },
})

export const getDefaultCommentCreateArgs = () => {
    return {
        createdAt: dateAsNumber(),
    }
}

export type CreateCommentArgs = UnionToTuple<keyof typeof createCommentValidator>
export type UpdateCommentArgs = UnionToTuple<keyof typeof updateCommentValidator>
